<template>
  <svg
    class="custom-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.4407 9.064C15.8531 8.47637 15.8531 7.52363 16.4407 6.936L22.936 0.440724C23.2282 0.148551 23.6106 0.00164766 23.9935 1.37824e-05C24.3808 -0.00163847 24.7685 0.145265 25.064 0.440725L31.5593 6.936C31.8521 7.22878 31.999 7.61219 32 7.99592L32 8.00013L32 8.00427C31.9989 8.38794 31.852 8.77127 31.5593 9.064L25.064 15.5593C24.4764 16.1469 23.5236 16.1469 22.936 15.5593L16.4407 9.064ZM24 12.3673L19.6327 8L24 3.63273L28.3673 8L24 12.3673Z"
    />
    <path
      d="M0.390589 19.0573C0.640632 18.8073 0.979751 18.6667 1.33336 18.6667H12.0001C12.3537 18.6667 12.6929 18.8073 12.9429 19.0573C13.1929 19.3073 13.3334 19.6465 13.3334 20.0001V30.6667C13.3334 31.0203 13.1929 31.3594 12.9429 31.6094C12.6929 31.8595 12.3537 32 12.0001 32H1.33336C0.979751 32 0.640632 31.8595 0.390589 31.6094C0.140547 31.3594 3.57324e-05 31.0203 0 30.6667V20.0001C3.57324e-05 19.6465 0.140547 19.3073 0.390589 19.0573Z"
    />
    <path
      d="M17.7241 19.0573C17.9741 18.8073 18.3132 18.6667 18.6668 18.6667H29.3336C29.6872 18.6667 30.0263 18.8073 30.2764 19.0573C30.5264 19.3073 30.6669 19.6465 30.6669 20.0001V30.6667C30.6669 31.0203 30.5264 31.3594 30.2764 31.6094C30.0263 31.8595 29.6872 32 29.3336 32H18.6668C18.3132 32 17.9741 31.8595 17.7241 31.6094C17.474 31.3594 17.3335 31.0203 17.3335 30.6667V20.0001C17.3335 19.6465 17.474 19.3073 17.7241 19.0573Z"
    />
    <path
      d="M0.390589 1.72405C0.640632 1.47401 0.979751 1.3335 1.33336 1.33346H12.0001C12.3537 1.3335 12.6929 1.47401 12.9429 1.72405C13.1929 1.97409 13.3334 2.3132 13.3334 2.66681V13.3334C13.3334 13.687 13.1929 14.0261 12.9429 14.2762C12.6929 14.5262 12.3537 14.6667 12.0001 14.6667H1.33336C0.979751 14.6667 0.640632 14.5262 0.390589 14.2762C0.140547 14.0261 3.57324e-05 13.687 0 13.3334V2.66681C3.57324e-05 2.3132 0.140547 1.97409 0.390589 1.72405Z"
    />
  </svg>
</template>
